/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { ITabViewProps } from '@msdyn365-commerce-modules/tab';

interface IExtendedTabViewProps extends ITabViewProps {
    config: ITabViewProps['config'] & { id: string };
}
const tabView: React.FC<IExtendedTabViewProps> = props => {
    const { heading, TabContainer, tabHeaders, tabContents, config } = props;
    if (!props.heading && !props.tabHeaders && !props.tabContents) {
        props.context.telemetry.error('Tab content is empty, module wont render');
        return null;
    }
    return (
        <Module id={config.id} {...TabContainer}>
            <Node {...props.headerSection}>{heading}</Node>
            <Node {...props.tabsSection}>{tabHeaders}</Node>
            <Node {...props.tabItemContainer}>{tabContents}</Node>
        </Module>
    );
};

export default tabView;
